function setCookie( name, value, expiration = '1h', path = '/', secure = true, same_site = 'Strict' ) {
    /* Setup */
    let d = new Date(),
        expiration_time = 0,
        tempDate = new Date(),
        cookie_string = name + '=' + value + ';'

    /* Check for defined expire */
    switch ( expiration ) {
        case '1h':
            expiration_time = 1*60*60*1000
        break;

        case '1d':
            expiration_time = 1*24*60*60*1000
        break;
        
        case '2d':
            expiration_time = 2*24*60*60*1000
        break;
        
        case '7d':
            expiration_time = 7*24*60*60*1000
        break;
        
        case '14d':
            expiration_time = 14*24*60*60*1000
        break;
        
        case '30d':
            expiration_time = 30*24*60*60*1000
        break;
        
        case '400d':
            expiration_time = 400*24*60*60*1000
        break;
        
        case '1m':
            tempDate.setMonth(tempDate.getMonth() + 1)
            expiration_time = tempDate.getTime() - d.getTime()
        break;
        
        case '3m':
            tempDate.setMonth(tempDate.getMonth() + 3)
            expiration_time = tempDate.getTime() - d.getTime()
        break;
        
        case '6m':
            tempDate.setMonth(tempDate.getMonth() + 6)
            expiration_time = tempDate.getTime() - d.getTime()
        break;
        
        case '9m':
            tempDate.setMonth(tempDate.getMonth() + 9)
            expiration_time = tempDate.getTime() - d.getTime()
        break;
        
        case '1y':
            tempDate.setFullYear(tempDate.getFullYear() + 1)
            expiration_time = tempDate.getTime() - d.getTime()
        break;
        
        case '2y':
            tempDate.setFullYear(tempDate.getFullYear() + 2)
            expiration_time = tempDate.getTime() - d.getTime()
        break;

        default:
        break;
    }

    /* Set time in object */
    if ( expiration_time > 0 ) {
        d.setTime( d.getTime() + expiration_time );
        cookie_string += 'expires=' + d.toUTCString() + '; '
    }

    /* Set path */
    cookie_string += 'path=' + path + '; ';

    /* Check for additional info */
    if ( secure ) {
        cookie_string += 'Secure; '
    }
    if ( same_site ) {
        cookie_string += 'SameSite=' + same_site + '; '
    }

    /* Set cookie */
    document.cookie = cookie_string;

    /* Return */
    return true
}

function getCookie( name ) {
    /* Check for cookie */
    const cookies = document.cookie.split("; ");

    /* Walk cookies and check for name */
    for (const cookie of cookies) {
        const [key, value] = cookie.split("=");
        if (key === name) return value;
    }

    /* Return */
    return null;
}

function deleteCookie( name, path = '/' ) {
    /* Set cookie to null and make it expire immediately */
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + path;
}

export {setCookie, getCookie, deleteCookie}
